import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-ink-deep py-10 text-slate-400 sm:py-12">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="font-serif text-lg text-white">
              Mgr. et Bc. Lenka Ježková
            </p>
            <p className="mt-1 text-[11px] uppercase tracking-[0.22em] text-bronze-light">
              Advokátní kancelář
            </p>
            <p className="mt-4 text-sm leading-relaxed">
              Vrchlického 530, 503 51 Chlumec nad Cidlinou IV
              <br />
              <a href="tel:+420721207779" className="hover:text-white">
                +420 721 207 779
              </a>
              {' · '}
              <a href="mailto:ak.jezkova@gmail.com" className="hover:text-white">
                ak.jezkova@gmail.com
              </a>
            </p>
          </div>

          <div className="text-sm leading-relaxed sm:text-right">
            <p>IČ: 674 80 381 · Ev. č. ČAK: 12271</p>
            <p>Zapsána v seznamu obhájců ex offo</p>
            <p className="mt-4 text-xs text-slate-500">
              © {new Date().getFullYear()} Advokátní kancelář Lenka Ježková
              <br />
              Provozuje AlgoInsight Technology
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
